import {
	companyPageApi,
	companyCreateApi,
	companyUpdateApi,
	productPageApi,
	delProductsApi,
	updateProductsApi,
	getAccountBalanceApi,
	getRateInfoApi
} from '@/apis/ins.js'
export default {
	async companyPage(context, params) {
		return companyPageApi(params)
	},
	async companyCreate(context, body) {
		return companyCreateApi(body)
	},
	async companyUpdate(context, body) {
		return companyUpdateApi(body)
	},
	async productPage(context, params) {
		return productPageApi(params)
	},
	async delProducts(context, ids) {
		return delProductsApi(ids)
	},
	async updateProducts(context, body) {
		return updateProductsApi(body)
	},
	async getAccountBalance(context, params={}) {
		return getAccountBalanceApi(params)
	},
	async getRateInfo(context) {
		return getRateInfoApi()
	}
}